import { Injectable } from '@angular/core';
import { HttpCustomService } from "./http-custom.service";

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    baseUrl = 'ws_app/';

    constructor(
        private customHttpService: HttpCustomService,
    ) {
    }

    getTaskUsers (callBack) {
        const path = this.baseUrl + `users/`;
        this.customHttpService.fetchData(path, callBack, false);
    }

    getTrendLine (data, callBack) {
        const path = this.baseUrl + `trend-line/`;
        this.customHttpService.postData(data, path, callBack, false);
    }

    getPieChart (data, callBack) {
        const path = this.baseUrl + `pie-chart/`;
        this.customHttpService.postData(data, path, callBack, false);
    }

    getReviewedCases (data, callBack) {
        const path = this.baseUrl + `per-reviews/`;
        this.customHttpService.postData(data, path, callBack, false);
    }

    getFTR (data, callBack) {
        const path = this.baseUrl + `ftr/`;
        this.customHttpService.postData(data, path, callBack, false);
    }
}
